<template>

    <el-dialog
        :title="title"
        class="font-normal"
        :visible="dialogVisible"
        width="30%"
        @close="$emit('close')">

        <div class="block">
            <el-date-picker
                v-model="selectedDate"
                type="date"
                class="w-full"
                placeholder="Pick a day"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
            </el-date-picker>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click.prevent="cancelNewReminder">Cancel</el-button>
            <el-button type="primary" @click.prevent="confirmDateSelection">Confirm</el-button>
        </span>
    </el-dialog>

</template>

<script>
    export default {
        name: "date-picker-modal",
        props: ["show", "title", "customPickerOptions", "defaultDate"],
        data () {
            return {
                selectedDate: this.defaultDate ? this.defaultDate : null,
                pickerOptions: this.customPickerOptions ? this.customPickerOptions : {},
                dialogVisible: this.show
            };
        },
        watch: {
            show (newVal) {
                this.resetSelectedDate();
                this.dialogVisible = newVal;
                if (!newVal) {
                    this.selectedDate = null;
                }
            }
        },
        methods: {
            resetSelectedDate(){
                this.selectedDate = this.defaultDate ? this.defaultDate : null;
            },
            cancelNewReminder () {
                this.dialogVisible = false;
            },
            confirmDateSelection () {
                this.$emit('date-confirmed', this.selectedDate);
                this.dialogVisible = false;
            },
        }
    };
</script>

<style scoped>

</style>
